import React from "react";
import BlockIcon from "@mui/icons-material/Block";
import CustomBtn from "../ButtonTemplate";

interface BlacklistBtnProps {
  action: () => void;
  addToList?: boolean;
}

function BlacklistBtn({ action, addToList = false }: BlacklistBtnProps) {
  const buttonStyles = addToList ? {
    "&:hover": {
      color: "#A9A9A9",
      background: "darkred",
    },
  } : {
    color: "#A9A9A9",
    background: "darkred",
    "&:hover": {
      background: "firebrick",
    },
  };

  return (
    <CustomBtn
      sx={buttonStyles}
      action={action}
      type="danger"
      icon={<BlockIcon />}
      tip={addToList ? "Blacklist Player" : "Remove from Blacklist"}
    />
  );
}

export default BlacklistBtn;
